export interface RegistruRow {
    nr: number;
    status: string | null;
    contractNumber: string | null;
    numeClient: string | null;
    pawnedItemDescription: string | null;
    unitOfMeasure: string | null;
    quantity: string | null;
    loanAmountEur: string | null;
    exchangeRate: string | null;
    loanAmount: string | null;
    dailyInterestRate: string | null;
    originalDueDate: string | null;
    redemptionDate: string | null;
    redemptionAmountEur: string | null;
    redemptionExchangeRate: string | null;
    redemptionAmountRon: string | null;
    expirationDate: string | null;
    contractDate: string | null;
    durationDays: number | null;
    staffCode: string | null;
    contractType: string | null;
    standardDiscountPercent: number | null;
}

export const registruCsvColumns: Array<{ field: keyof RegistruRow; label: string }> = [
    { field: 'status', label: 'Statut' },
    { field: 'contractNumber', label: 'Nr. contract' },
    { field: 'numeClient', label: 'Client' },
    { field: 'pawnedItemDescription', label: 'Obiect amanetat' },
    { field: 'unitOfMeasure', label: 'UM' },
    { field: 'quantity', label: 'Cantitate' },
    { field: 'loanAmountEur', label: 'Suma EUR' },
    { field: 'exchangeRate', label: 'Curs BNR' },
    { field: 'loanAmount', label: 'Suma RON' },
    { field: 'dailyInterestRate', label: 'Comision/zi' },
    { field: 'originalDueDate', label: 'Termen restituire' },
    { field: 'redemptionDate', label: 'Data restituire' },
    { field: 'redemptionAmountEur', label: 'Restituire EUR' },
    { field: 'redemptionExchangeRate', label: 'Curs restituire' },
    { field: 'redemptionAmountRon', label: 'Restituire RON' },
    { field: 'expirationDate', label: 'Data expirare' },
    { field: 'contractDate', label: 'Data contract' },
    { field: 'durationDays', label: 'Durata' },
    { field: 'staffCode', label: 'Personal' },
    { field: 'contractType', label: 'Tip contract' },
    { field: 'standardDiscountPercent', label: 'Reducere standard' },
];

const escapeCsvValue = (value: string | number | null): string => {
    const text = String(value ?? '');
    return `"${text.replace(/"/g, '""')}"`;
};

export const createRegistruCsv = (rows: RegistruRow[]): string =>
    [
        registruCsvColumns.map(column => escapeCsvValue(column.label)).join(','),
        ...rows.map(row =>
            registruCsvColumns.map(column => escapeCsvValue(row[column.field])).join(','),
        ),
    ].join('\r\n');
